
(function () {
  // Prod and dev store IDs for "STRIKECO - Pre order deposit"; the handle
  // matches on both stores and covers any future re-import.
  var DEPOSIT_PRODUCT_IDS = [8919738777769, 8368359931951];
  var DEPOSIT_HANDLE = 'strikeco';
  var MAX_QTY = 1;
  var busy = false;
  var atLimit = false;

  function isDeposit(item) {
    return DEPOSIT_PRODUCT_IDS.indexOf(item.product_id) !== -1 || item.handle === DEPOSIT_HANDLE;
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // Open the theme's "added to cart" notification (popover or cart drawer,
  // whichever the theme is configured for) showing the item already in the
  // cart, without adding anything.
  function showExistingItem(variantId) {
    Promise.all([
      fetch(root() + 'variants/' + variantId + '?sections=variant-added', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }),
      fetch(root() + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }),
    ]).then(function (results) {
      var sections = results[0];
      var cart = results[1];
      if (sections['variant-added']) {
        sections['variant-added'] = sections['variant-added']
          .replace('Added to your cart!', 'Already in your cart');
      }
      cart.sections = sections;
      document.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: [], cart: cart },
      }));
    }).catch(function () {
      window.location.href = root() + 'cart';
    });
  }

  // Runs in the capture phase so it wins over the theme's own product-form
  // submit handler.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!atLimit || !form.matches('form[action*="/cart/add"]')) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    var idInput = form.querySelector('[name="id"]');
    if (idInput && idInput.value) {
      showExistingItem(idInput.value);
    } else {
      window.location.href = root() + 'cart';
    }
  }, true);

  function sync() {
    fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(isDeposit);
        var total = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
        atLimit = total >= MAX_QTY;
        if (total > MAX_QTY && !busy) {
          busy = true;
          fetch(root() + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lines[0].key, quantity: MAX_QTY }),
          }).then(function () { window.location.reload(); })
            .catch(function () { busy = false; });
        }
      }).catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = String(arguments[0] && arguments[0].url || arguments[0] || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(sync, 300); });
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
